import styled, { css } from 'styled-components';
import { BUTTON_SECTION_HEIGHT_PERCENTEGES, device } from 'constants/index';
import { Button } from 'components/Button/Button';

const QUESTION_MIN_HEIGHT = 40;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  flex: 1;
  padding: 0 100px;
  max-height: 100%;

  & .question {
    color: #1c1c1c;
    font-size: 20px;
    font-weight: 500;
  }

  & .answers {
    display: flex;
    flex-direction: column;
    gap: 18px;

    & .answer {
      text-decoration: none;
      list-style: none;
    }
  }

  & .buttonSection {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: ${BUTTON_SECTION_HEIGHT_PERCENTEGES}%;

    & .buttonContent {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 9px;
      font-family: "Dexa Pro";
      font-weight: 600;
    }
  }

  & .more {
    height: calc(100% - ${BUTTON_SECTION_HEIGHT_PERCENTEGES}%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    color: #000;
    font-size: 20px;
    font-weight: 500;

    & .moreButton {
      padding: 5px 8px;
      background: transparent;
      border: none;
      text-decoration: underline;
      color: #4069ed;
      font-size: 20px;
      font-weight: 500;
      cursor: pointer;
    }
  }

  @media ${device.lg} {
    padding: 0 30px;
  }
  @media ${device.md} {
    padding: 0 30px;
  }
`;

const QuestionStep = styled.p`
  color: #A8A9AD;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-family: "Dexa Pro";
  font-weight: 600;
  line-height: 30px;
  @media ${device.md} {
    position: absolute;
    top: 60px;
    right: 30px;
    line-height: 24px;
    font-size: 18px;
  }
` 

const Label = styled.span`
   @media ${device.md} {
    display: none;
   }
`

const QuestionText = styled.p`
  margin-top: 20px;
  margin-bottom: 60px;
  max-width: 80%;
  height: 100px;
  color: #1C1C1C;
  text-align: center;
  font-family: "Dexa Pro Expanded";
  font-size: 34px;
  font-style: normal;
  font-weight: 500;
  line-height: 48px;
  @media ${device.lg} {
    margin-top: 10px;
    margin-bottom: 10px;
    max-width: 100%;
  }
  @media ${device.md} {
    margin-top: 60px;
    margin-bottom: 30px;
    line-height: 28px;
    font-size: 20px;
  }
`

const QuestionContent =  styled.div`
  // height: calc(100% - ${BUTTON_SECTION_HEIGHT_PERCENTEGES}%);
  display: flex;
  flex-direction: column;
  align-items: center;
`

const QuestionAnswersAndPic = styled.div`
  width: 100%;
  padding: 0 120px 60px;
  border-bottom: 1px solid #D9D9D9;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 60px;
  justify-content: center;
  @media ${device.lg} {
    padding: 0;
    border-bottom: none;
  }
  @media ${device.md} {
    flex-direction: column;
    gap: 0;
    justify-content: flex-start;
    align-items: center;
    padding: 0;
    border-bottom: none;
  }
`

const QuestionImage = styled.img`
  width: 400px;
  height: 400px;
  border-radius: 5px;
  flex-shrink: 0;
  object-fit: cover;
  @media ${device.md} {
    width: 100%;
    height: unset;
    object-fit: contain;
    margin-bottom: 25px;
    border-radius: 10px;
  }
`

const BottomButtonSection = styled.div`
  margin-top: 40px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding-right: 120px;
  @media ${device.lg} {
    margin-top: 30px;
    padding-right: 0;
  }
  @media ${device.md} {
    padding: 0;
  }
`

const BottomButton = styled(Button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 12px 25px;
  max-width: 200px;
  @media ${device.md} {
    width: 100%;
    max-width: unset;
    margin-bottom: 6%;
  }
`

const ButtonText = styled.span``

const ButtonContent = styled.div``

const QuestionAnswers = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  gap: 20px;
  height: 100%;
  @media ${device.md} {
    gap: 15px;
  }
`
const QuestionAnswer = styled.li`
  text-decoration: none;
  list-style: none;
  height: 85px;
  @media ${device.md} {
    height: 65px;
  }
`

const AnswerNumber = styled.div`
  display: flex;
  width: 25px;
  height: 25px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #D9D9D9;
  border-radius: 5px;

  color: #D9D9D9;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-family: "Dexa Pro";
  font-weight: 400;
  line-height: 85px;
`

const AnswerText = styled.span`
  line-height: 25px;
  font-family: "Dexa Pro";
  font-weight: 400;
  @media ${device.md} {
    line-height: 22px;
    font-size: 16px;
  }
`

const AnswerButton = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>`
  width: 100%;
  height: 100%;
  border: none;
  background: #F8F8F8;
  border-radius: 10px;
  padding: 20px 30px;
  box-shadow: 2px 2px 1px 1px #D9D9D9;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;

  text-align: center;
  color: #5F5F63;
  font-size: 18px;
  font-weight: 400;
  line-height: 85px;

  outline: none;

  cursor: pointer;

  ${({ isActive }) =>
    isActive &&
    css`
      border: none;
      background: #F0F4FD;
      box-shadow: 2px 2px 1px 1px #4069ED;
      ${AnswerNumber} {
        border: 1px solid #4069ED;
        background: #4069ED;
        color: #fff;
      }
    `}
`;

const ResultsButton = styled(Button)`
  height: 54px;
  line-height: 54px;
`

const MoreWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media ${device.md} {
    ${ResultsButton} {
      width: 100%;
    }
    padding-bottom: 6%;
  }
`

const MoreDescription = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media ${device.md} {
    height: 100%;
  }
`

const MoreText = styled.p`
  color: #1C1C1C;
  text-align: center;
  font-size: 34px;
  font-style: normal;
  font-weight: 500;
  line-height: 48px;
  margin-bottom: 10px;
  @media ${device.md} {
    margin-bottom: 30px;
  }
`

const MoreButton = styled.button`
  color: #4069ED;
  text-align: center;
  background-color: transparent;
  font-size: 20px;
  font-style: normal;
  font-family: "Dexa Pro";
  font-weight: 400;
  line-height: 30px;
  text-decoration: underline;
  border: none;
  outline: none;
  cursor: pointer;
  margin-bottom: 60px;
`

const SubmitButton = styled(Button)`
  @media ${device.md} {
    width: 100%;
    max-width: unset;
    margin-bottom: 6%;
  }
`

export { 
  Wrapper, 
  AnswerButton,
  QuestionStep,
  QuestionText,
  QuestionContent,
  QuestionAnswersAndPic,
  QuestionImage,
  BottomButtonSection,
  BottomButton,
  ButtonText,
  ButtonContent,
  QuestionAnswers,
  QuestionAnswer,
  AnswerNumber,
  AnswerText,
  ResultsButton,
  MoreWrapper,
  MoreText,
  MoreButton,
  MoreDescription,
  Label,
  SubmitButton
};
